export const VerifyHost = process.env.NODE_ENV === 'development' ? 'http://watch.zxsmart.cn' : ''
